<div class="milestone-dialog">
  <!-- Dialog Header -->
  <div class="dialog-header">
    <div class="header-icon">
      <mat-icon>flag</mat-icon>
    </div>
    <h2>Add Milestones</h2>
    <button class="close-btn" (click)="cancel()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- Dialog Content -->
  <div class="dialog-content">
    <div class="tabs-ui" style="width: 100%;">
      <div class="tabs-ui-contents">
        <div class="tabs-ui-content tabs-ui-content-active">

          <!-- Loading Spinner -->
          @if (isLoading) {
            <div style="text-align: center; padding: 50px;">
              <mat-spinner diameter="50" style="margin: 0 auto;"></mat-spinner>
              <p style="margin-top: 20px;">Loading milestone templates...</p>
            </div>
          }

          <!-- Templates Section -->
          @if (!isLoading) {
            <div>

              <!-- ========================================================= -->
              <!-- Needs your action — STATIC DEMO (mock data, for client UI  -->
              <!-- approval). Replace with dynamic conditions-based output.   -->
              <!-- ========================================================= -->
              @if (suggestions.length > 0) {
                <div class="nya">
                  <div class="nya__head" (click)="toggleSuggestions()">
                    <div class="nya__head-left">
                      <span class="nya__icon"><mat-icon>bolt</mat-icon></span>
                      <div>
                        <h3 class="nya__title">
                          Smart Suggestions
                          <span class="nya__count">{{ suggestions.length }}</span>
                        </h3>
                        <p class="nya__sub">
                          These milestones match this record's current details and aren't added yet.
                        </p>
                      </div>
                    </div>
                    <mat-icon class="nya__chev" [class.is-open]="suggestionsExpanded">expand_more</mat-icon>
                  </div>

                  @if (suggestionsExpanded) {
                    <div class="nya__list">
                      @for (s of suggestions; track s.id) {
                        <div class="nya__card">
                          <div class="nya__card-main">
                            <span class="nya__ms-name">{{ s.name }}</span>
                            <span class="nya__from">
                              <mat-icon>account_tree</mat-icon>{{ s.templateName }}
                            </span>
                            <span class="nya__chips">
                              @for (m of s.matched; track m) {
                                <span class="nya__chip"><mat-icon>check_circle</mat-icon>{{ m }}</span>
                              }
                            </span>
                          </div>
                          <button class="nya__add" (click)="addSuggestion(s)">
                            <mat-icon>add</mat-icon> Add
                          </button>
                        </div>
                      }
                    </div>
                  }
                </div>

                <div class="nya__divider"><span>or browse all templates</span></div>
              }

              <!-- Search Field -->
              <div class="search-field-wrapper mb-2">
                <div class="search-input-container">
                  <i class="fas fa-search search-icon"></i>
                  <input
                    type="text"
                    class="search-input"
                    placeholder="Search milestones by name..."
                    [(ngModel)]="searchQuery"
                    (keyup.enter)="onSearchEnter()"
                    (input)="onSearchInput()"
                    #searchInput>
                  @if (searchQuery) {
                    <button
                      class="clear-search-btn"
                      (click)="clearSearch()">
                      <i class="fas fa-times"></i>
                    </button>
                  }
                </div>
                @if (!searchQuery) {
                  <div class="search-hint">
                    <small>Type milestone name and press Enter to search</small>
                  </div>
                }
              </div>
              <!-- No Search Message - Show when no search has been performed and no templates selected -->
              @if (templates.length === 0 && !searchQuery && selectedTemplates.length === 0) {
                <div class="cards">
                  <article class="information [ card-info ]">
                    <span class="tag"></span>
                    <h2 class="title">No templates available</h2>
                    <p class="info">There are no milestone templates for this module yet.</p>
                  </article>
                </div>
              }
              <!-- No Results Message - Show when search returned no results -->
              @if (templates.length === 0 && searchQuery) {
                <div class="cards">
                  <article class="information [ card-info ]">
                    <span class="tag"></span>
                    <h2 class="title">No templates found!</h2>
                    <p class="info">No milestone templates found matching "{{ searchQuery }}".</p>
                  </article>
                </div>
              }
              <!-- Browsable template listing (also used for search results) -->
              @if (templates.length > 0) {
                <div>
                  <!-- Results Container with close button -->
                  <div class="search-results-container px-3 mb-3">
                    <div class="d-flex justify-content-between align-items-center mb-2">
                      <small class="text-muted">{{ searchQuery ? 'Search Results' : 'Available Templates' }}</small>
                      @if (searchQuery) {
                        <button class="btn btn-sm btn-link p-0" (click)="clearSearch()">
                          <i class="fas fa-times text-muted"></i>
                        </button>
                      }
                    </div>
                    <div class="list-group" style="max-height: 200px; overflow-y: auto;">
                      @for (template of templates; track template; let i = $index) {
                        <div class="list-group-item d-flex align-items-center py-3"
                          >
                          <i class="fas fa-check-circle mr-3"
                            [class.text-success]="isTemplateSelected(template)"
                            [class.text-muted]="!isTemplateSelected(template)"
                            (click)="toggleTemplateSelection(template, {checked: !isTemplateSelected(template)})"
                          style="font-size: 20px; cursor: pointer;"></i>
                          <div>
                            <h5 class="mb-0 font-weight-bold">{{ template.name }}</h5>
                            <small class="text-muted" style="font-size: 12px;">{{ template.milestones?.length || 0 }} milestones</small>
                          </div>
                        </div>
                      }
                    </div>
                  </div>
                </div>
              }
              <!-- Show Selected Templates with Full Hierarchy when NOT searching -->
              @if (!searchQuery && selectedTemplates.length > 0) {
                <div class="px-3" style="max-height: 400px; overflow-y: auto;">
                  <!-- Template Parent Card -->
                  @for (template of selectedTemplates; track template; let i = $index) {
                    <div class="card mb-2 shadow">
                      <!-- Template Header - Clickable -->
                      <div class="card-header bg-light border-bottom py-3" style="cursor: pointer;">
                        <div class="d-flex justify-content-between align-items-center">
                          <div class="d-flex align-items-center">
                            <i class="fas fa-check-circle mr-3"
                              [class.text-success]="isTemplateSelected(template)"
                              [class.text-muted]="!isTemplateSelected(template)"
                              (click)="toggleTemplateSelection(template, {checked: !isTemplateSelected(template)}); $event.stopPropagation()"
                            style="font-size: 20px; cursor: pointer;"></i>
                            <h4 class="mb-0 text-dark font-weight-bold" (click)="toggleTemplate('template' + i)">{{ template.name }}</h4>
                          </div>
                          <i class="fas fa-chevron-down"
                            [class.fa-chevron-down]="!expandedTemplates['template' + i]"
                            [class.fa-chevron-up]="expandedTemplates['template' + i]"
                            (click)="toggleTemplate('template' + i)"
                          style="color: #FF6600;"></i>
                        </div>
                      </div>
                      <!-- Template Body containing milestones - Collapsible -->
                      @if (expandedTemplates['template' + i]) {
                        <div class="card-body p-3">
                          <!-- Milestones List -->
                          @if (template.milestones && template.milestones.length > 0) {
                            <div>
                              @for (milestone of template.milestones; track milestone; let j = $index; let isLast = $last) {
                                <div class="milestone-container">
                                  <!-- Milestone Card - Clickable Header -->
                                  <div class="card mb-3 border-left-primary" style="border-left: 4px solid #FF6600;">
                                    <div class="card-body py-3">
                                      <div class="d-flex align-items-center justify-content-between">
                                        <div class="d-flex align-items-center">
                                          <i class="fas fa-check-circle mr-2"
                                            [class.text-success]="isMilestoneSelected(milestone)"
                                            [class.text-muted]="!isMilestoneSelected(milestone)"
                                            (click)="toggleMilestone(milestone)"
                                          style="font-size: 16px; cursor: pointer;"></i>
                                          <span class="font-weight-bold" style="font-size: 15px;">{{ milestone.name }}</span>
                                        </div>
                                        @if (milestone.tasks && milestone.tasks.length > 0) {
                                          <i class="fas fa-chevron-down cursor-pointer"
                                            [class.fa-chevron-down]="!expandedMilestones['template' + i + '_milestone' + j]"
                                            [class.fa-chevron-up]="expandedMilestones['template' + i + '_milestone' + j]"
                                            (click)="toggleMilestoneExpansion('template' + i + '_milestone' + j)"
                                          style="color: #6c757d; font-size: 14px;"></i>
                                        }
                                      </div>
                                    </div>
                                  </div>
                                  <!-- Tasks Container with vertical line - Collapsible -->
                                  @if (milestone.tasks && milestone.tasks.length > 0 && expandedMilestones['template' + i + '_milestone' + j]) {
                                    <div class="position-relative">
                                      <!-- Vertical Line -->
                                      <div class="position-absolute" style="left: 20px; top: 0; bottom: 0; width: 2px; background-color: #FF6600; opacity: 0.3;"></div>
                                      <!-- Task Cards - More Prominent -->
                                      <div class="pl-5">
                                        @for (task of milestone.tasks; track task; let taskLast = $last) {
                                          <div class="card mb-2 shadow-sm">
                                            <div class="card-body py-2 px-3">
                                              <div class="d-flex align-items-center">
                                                <i class="fas fa-check-circle mr-2"
                                                  [class.text-success]="isTaskSelected(task)"
                                                  [class.text-muted]="!isTaskSelected(task)"
                                                  (click)="toggleTask(task, milestone)"
                                                style="font-size: 14px; cursor: pointer;"></i>
                                                <span class="text-dark">{{ task.task_name }}</span>
                                              </div>
                                            </div>
                                          </div>
                                        }
                                      </div>
                                    </div>
                                  }
                                  <!-- Spacer between milestones -->
                                  @if (!isLast) {
                                    <div class="mb-3"></div>
                                  }
                                </div>
                              }
                            </div>
                          }
                          <!-- No milestones message -->
                          @if (!template.milestones || template.milestones.length === 0) {
                            <div>
                              <p class="text-muted text-center mb-0">No milestones available in this template</p>
                            </div>
                          }
                        </div>
                      }
                    </div>
                  }
                </div>
              }
            </div>
          }
        </div>
      </div>
    </div>
  </div>

  <!-- Dialog Footer -->
  <div class="dialog-footer">
    <button class="btn-cancel" (click)="cancel()">
      <mat-icon>close</mat-icon>
      Cancel
    </button>
    <button class="btn-submit" [disabled]="selectedMilestones.size === 0 || isLoading" (click)="save()">
      @if (isLoading) {
        <mat-spinner diameter="16" class="btn-spinner"></mat-spinner>
      } @else {
        <mat-icon>add</mat-icon>
      }
      <span>Add Milestones</span>
    </button>
  </div>
</div>